export enum PaymentOption {
    Cash = "cash",
    PayPal = "paypal",
    StripeApplePay = "applepay",
    StripeCreditCard = "card",
    StripeGiroPay = "giropay",
    StripeGooglePay = "googlepay",
}
